import { GET_LIST_LOCATIONS_FOLLOWERS } from 'api'
import { getLocationsListFollowers } from 'api/get/locations'
import {
	BoxSwitch,
	DropdownFull,
	Image,
	LibraryImage,
	Slide,
	Typography
} from 'components'
import {
	CreateNewContentProps,
	DropdownFullItemProps,
	Icons,
	ItemDataAssentsAll,
	ItemSelect,
	TypographyTypes
} from 'interfaces'
import { contentTypeData } from 'lib'
import React, { useEffect, useState } from 'react'
import { useQuery } from 'react-query'
import Select from 'react-select'
import Cookies from 'universal-cookie'
import { regexVimeoOrYoutube } from 'utils'
import { ContentAssetSlot } from './contentAssetButton'

export const CreateNewContent: React.FC<CreateNewContentProps> = ({
	totalData,
	listImage,
	setTotalData,
	setListImage,
	mode,
	typeFunction = 'Content',
	videoId,
	setVideoId,
	setValueInput,
	valueInput,
	setOpenDocument,
	documentsList
}): JSX.Element => {
	const [saving, setSaving] = useState(false)
	const [sharing, setSharing] = useState(false)
	const [openSlide, setOpenSlide] = useState(false)
	const [slideImages, setSlideImages] = useState(false)
	const [slideLibraryImages, setSlideLibraryImages] = useState(false)
	const [isCropSettingsVisible, setIsCropSettingsVisible] = useState(true)
	const [isFinishCropButtonVisible, setIsFinishCropButtonVisible] =
		useState(true)
	const [isCropComplete, setIsCropComplete] = useState(false)
	const [locationsListElement, setLocationListElement] = useState<ItemSelect[]>(
		[]
	)
	const [contentType, setContentType] = useState<DropdownFullItemProps>({
		id: 0,
		name:
			typeFunction === 'Content' ? 'Content Type' : 'Add to an existing list'
	})
	const [dataContentType, setDataContentType] = useState<ItemSelect[]>([])
	const cookies = new Cookies()
	const [nameSlide, setNameSlide] = useState('')

	const userId = cookies.get('userId')
	const organizationId = cookies.get('organization_id')
	const [sendImageCropped, setSendImageCropped] = useState<
		ItemDataAssentsAll[]
	>([])

	useEffect(() => {
		if (!openSlide) {
			setNameSlide('')
			setSlideImages(false)
			setSlideLibraryImages(false)
		}
	}, [openSlide])

	useEffect(() => {
		setTotalData({
			...totalData,
			basic_setup: {
				...totalData.basic_setup,
				category: contentType.value ? contentType.value : ''
			}
		})
	}, [contentType])

	useEffect(() => {
		setTotalData({
			...totalData,
			basic_setup: {
				...totalData.basic_setup,
				saving
			}
		})
	}, [saving])

	useEffect(() => {
		setTotalData({
			...totalData,
			basic_setup: {
				...totalData.basic_setup,
				sharing
			}
		})
	}, [sharing])

	useEffect(() => {
		if (totalData.basic_setup.category !== '') {
			if (typeFunction === 'Content') {
				const aux = contentTypeData.find(
					item => item.value === totalData.basic_setup.category
				)

				if (aux !== undefined) {
					setContentType(aux)
				}
			}

			if (typeFunction !== 'Content') {
				const dataIds =
					totalData.basic_setup.category !== 'Add to an existing list'
						? JSON.parse(totalData.basic_setup.category)
						: null
				if (dataIds) {
					const matchingObjects = dataContentType.filter(obj =>
						dataIds.includes(obj.value)
					)
					if (matchingObjects.length > 0) {
						setLocationListElement(matchingObjects)
						setContentType({
							name: 'location list',
							value: JSON.stringify(matchingObjects)
						})
					}
				}
			}
		}
		setSharing(totalData.basic_setup.sharing)
		setSaving(totalData.basic_setup.saving)
		if (totalData.basic_setup.preview) {
			setListImage(totalData.basic_setup.preview.files)
			setSendImageCropped(totalData.basic_setup.preview.files)
			setVideoId?.(totalData.basic_setup.preview.video_link_external)
		}
	}, [totalData, dataContentType, dataContentType])

	const { data: dataListsLocations } = useQuery(
		[GET_LIST_LOCATIONS_FOLLOWERS, userId, organizationId],
		() => getLocationsListFollowers(organizationId),
		{
			enabled: typeFunction === 'Location'
		}
	)

	useEffect(() => {
		if (dataListsLocations && dataListsLocations.items.length > 0) {
			const dataInputSelect = dataListsLocations.items.map(element => {
				return {
					label: element.name,
					value: element.id
				}
			})
			setDataContentType(dataInputSelect)
		} else {
			setDataContentType([])
		}
	}, [dataListsLocations])

	const hasImages = Boolean(listImage?.length)

	const hasVideo =
		!hasImages &&
		(regexVimeoOrYoutube.test(videoId as string) ||
			regexVimeoOrYoutube.test(valueInput as string))

	const hasPdf = !hasImages && !hasVideo && !!documentsList?.length
	const emptyAssets = !hasImages && !hasVideo && !hasPdf

	return (
		<div className="flex-col h-full relative">
			<Slide
				title={nameSlide}
				open={openSlide}
				scroll={slideLibraryImages}
				setOpen={setOpenSlide}
				classNameTitle="!font-bold"
				wide={false}
			>
				<>
					{slideImages && (
						<Image
							sendImageCropped={sendImageCropped}
							setSendImageCropped={setSendImageCropped}
							isCropSettingsVisible={isCropSettingsVisible}
							setIsCropSettingsVisible={setIsCropSettingsVisible}
							setIsFinishCropButtonVisible={setIsFinishCropButtonVisible}
							isFinishCropButtonVisible={isFinishCropButtonVisible}
							isCropComplete={isCropComplete}
							setIsCropComplete={setIsCropComplete}
							totalData={totalData}
							listImage={listImage}
							setOpenSlide={setOpenSlide}
							setTotalData={setTotalData}
							setListImage={setListImage}
							setSlideImages={state => {
								setNameSlide('Crop Image')
								setSlideImages(state)
							}}
							setSlideLibraryImages={state => {
								setNameSlide('Add Images From Library')
								setSlideLibraryImages(state)
							}}
							mode={mode}
							setVideoId={setVideoId}
							videoId={videoId}
							setValueInput={setValueInput}
							valueInput={valueInput}
						/>
					)}
					{slideLibraryImages && (
						<LibraryImage
							setSendImageCropped={setSendImageCropped}
							listImage={listImage}
							setOpenSlide={setOpenSlide}
							setListImage={setListImage}
							setSlideImages={state => {
								setNameSlide('')
								setSlideImages(state)
							}}
							setSlideLibraryImages={state => {
								setNameSlide('')
								setSlideLibraryImages(state)
							}}
							libaryType={typeFunction === 'Content' ? 'contents' : 'locations'}
						/>
					)}
				</>
			</Slide>
			<div className="flex flex-col h-full">
				<Typography
					className="text-gray-9"
					type={TypographyTypes.h2}
					title={`${mode === 'create' ? 'Create New' : 'Edit'} ${typeFunction}`}
					fontLeading="31/37"
				/>
				<Typography
					title="Preview:"
					type={TypographyTypes.h3}
					className="text-lavender"
					fontLeading="18/21"
				/>

				<ContentAssetSlot
					setSlideImages={setSlideImages}
					setOpenSlide={setOpenSlide}
					emptyAssets={Boolean(emptyAssets)}
					hasImages={hasImages}
					hasPdf={Boolean(hasPdf)}
					hasVideo={Boolean(hasVideo)}
					onClickPdf={() => {
						setOpenDocument?.(true)
					}}
					onClickMedia={() => {
						setOpenSlide(true)
						setSlideImages(true)
						setNameSlide('Add Images/Video')
					}}
					onClickLibrary={() => {
						setOpenSlide(true)
						setSlideLibraryImages(true)
						setNameSlide('Add Images From Library')
					}}
					onClickVideo={() => {
						setOpenSlide(true)
						setSlideImages(true)
						setNameSlide('Add Video from Link')
					}}
					imageSrc={listImage?.[0]?.asset_url}
					videoSrc={videoId || valueInput}
					listImage={listImage}
					videoUrl={videoId || valueInput}
				/>
				<div className="mt-11">
					{typeFunction === 'Content' ? (
						<DropdownFull
							list={contentTypeData}
							item={contentType}
							setItem={setContentType}
						/>
					) : (
						<Select
							value={locationsListElement}
							isMulti
							name="list"
							options={dataContentType}
							className="basic-multi-select"
							classNamePrefix="select"
							placeholder="Add to an existing list"
							onChange={e => {
								setContentType({
									name: 'location list',
									value: JSON.stringify(e)
								})
								setLocationListElement(e as ItemSelect[])
							}}
						/>
					)}
				</div>

				{typeFunction === 'Content' && (
					<div>
						<BoxSwitch
							border
							title="Sharing"
							enabled={sharing}
							icon={Icons.share}
							setEnabled={setSharing}
						/>
						<BoxSwitch
							border
							title="Saving"
							enabled={saving}
							icon={Icons.bookmark}
							setEnabled={setSaving}
						/>
					</div>
				)}
			</div>
		</div>
	)
}
